import React, { FC } from 'react';
import { Text, View } from 'react-native';
import Loading from '@components/loading';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { TRACEABILITY_GRAPH_GEOMETRY } from '@v2/pages/common/components/TraceabilityGraph/constants';
import { TraceabilityGraphProps } from '@v2/pages/common/components/TraceabilityGraph/types';

export const EmptyColumnSlot: FC<Pick<TraceabilityGraphProps, 'C'> & { loading?: boolean }> = ({ C, loading }) => (
  <View
    style={{
      width: '100%',
      minHeight: scale(TRACEABILITY_GRAPH_GEOMETRY.cardMinHeight),
      borderRadius: scale(10),
      borderWidth: scale(1),
      borderColor: C('Hairline/Light/No trans'),
      borderStyle: 'dashed',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 0.5,
    }}
  >
    {loading ? (
      <Loading background="transparent" />
    ) : (
      <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>—</Text>
    )}
  </View>
);
